import { render, staticRenderFns } from "./VaDataTableApiModeExample.vue?vue&type=template&id=317dd818&"
import script from "./VaDataTableApiModeExample.vue?vue&type=script&lang=js&"
export * from "./VaDataTableApiModeExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports